/*import { useState, useEffect } from "react";
import API_URL from "../config";

const EMPTY_SLIDE = { titre: "", description: "", imageUrl: "", ordre: 0, actif: true };
const EMPTY_TUILE = { titre: "", imageUrl: "", lien: "", taille: "petite", ordre: 0, actif: true };

export default function AdminSlide() {
  const [slides, setSlides] = useState([]);
  const [tuiles, setTuiles] = useState([]);
  const [slideForm, setSlideForm] = useState(EMPTY_SLIDE);
  const [tuileForm, setTuileForm] = useState(EMPTY_TUILE);
  const [slideEditId, setSlideEditId] = useState(null);
  const [tuileEditId, setTuileEditId] = useState(null);
  const [slideFormOpen, setSlideFormOpen] = useState(false);
  const [tuileFormOpen, setTuileFormOpen] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [slidePreview, setSlidePreview] = useState("");
  const [tuilePreview, setTuilePreview] = useState("");

  useEffect(() => { fetchSlides(); fetchTuiles(); }, []);

  const fetchSlides = async () => {
    const res = await fetch(`${API_URL}/api/slides/all`);
    setSlides(await res.json());
  };

  const fetchTuiles = async () => {
    const res = await fetch(`${API_URL}/api/tuiles/all`);
    setTuiles(await res.json());
  };

  const notify = (msg) => {
    setFeedback(msg);
    setTimeout(() => setFeedback(""), 3000);
  };

  // ── Slides handlers ──────────────────────────────────────────
  const handleSlideChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    setSlideForm(prev => ({ ...prev, [name]: val }));
    if (name === "imageUrl") setSlidePreview(value);
  };

  const handleSlideSubmit = async (e) => {
    e.preventDefault();
    const method = slideEditId ? "PUT" : "POST";
    const url = slideEditId ? `${API_URL}/api/slides/${slideEditId}` : `${API_URL}/api/slides`;
    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(slideForm),
    });
    if (res.ok) {
      notify(slideEditId ? "✅ Slide modifié !" : "✅ Slide ajouté !");
      setSlideForm(EMPTY_SLIDE);
      setSlideEditId(null);
      setSlideFormOpen(false);
      setSlidePreview("");
      fetchSlides();
    }
  };

  const handleSlideEdit = (slide) => {
    setSlideForm({ titre: slide.titre, description: slide.description, imageUrl: slide.imageUrl, ordre: slide.ordre, actif: slide.actif });
    setSlideEditId(slide._id);
    setSlidePreview(slide.imageUrl);
    setSlideFormOpen(true);
  };

  const handleSlideDelete = async (id) => {
    if (!window.confirm("Supprimer ce slide ?")) return;
    await fetch(`${API_URL}/api/slides/${id}`, { method: "DELETE" });
    notify("🗑️ Slide supprimé");
    fetchSlides();
  };

  // ── Tuiles handlers ──────────────────────────────────────────
  const handleTuileChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    setTuileForm(prev => ({ ...prev, [name]: val }));
    if (name === "imageUrl") setTuilePreview(value);
  };

  const handleTuileSubmit = async (e) => {
    e.preventDefault();
    const method = tuileEditId ? "PUT" : "POST";
    const url = tuileEditId ? `${API_URL}/api/tuiles/${tuileEditId}` : `${API_URL}/api/tuiles`;
    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tuileForm),
    });
    if (res.ok) {
      notify(tuileEditId ? "✅ Tuile modifiée !" : "✅ Tuile ajoutée !");
      setTuileForm(EMPTY_TUILE);
      setTuileEditId(null);
      setTuileFormOpen(false);
      setTuilePreview("");
      fetchTuiles();
    }
  };

  const handleTuileEdit = (tuile) => {
    setTuileForm({ titre: tuile.titre, imageUrl: tuile.imageUrl, lien: tuile.lien, taille: tuile.taille, ordre: tuile.ordre, actif: tuile.actif });
    setTuileEditId(tuile._id);
    setTuilePreview(tuile.imageUrl);
    setTuileFormOpen(true);
  };

  const handleTuileDelete = async (id) => {
    if (!window.confirm("Supprimer cette tuile ?")) return;
    await fetch(`${API_URL}/api/tuiles/${id}`, { method: "DELETE" });
    notify("🗑️ Tuile supprimée");
    fetchTuiles();
  };

  return (
    <div className="mt-10 space-y-12">

      {feedback && (
        <div className="p-3 bg-green-50 border border-green-200 text-green-700 rounded-lg text-sm">
          {feedback}
        </div>
      )}


      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-gray-900">🖼️ Carrousel</h2>
          <button
            onClick={() => { setSlideFormOpen(true); setSlideForm(EMPTY_SLIDE); setSlideEditId(null); }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-medium"
          >
            ＋ Ajouter un slide
          </button>
        </div>

        {slideFormOpen && (
          <div className="bg-white border-2 border-blue-200 rounded-xl p-6 mb-6">
            <h3 className="text-lg font-bold mb-4">{slideEditId ? "✏️ Modifier" : "➕ Nouveau slide"}</h3>
            <form onSubmit={handleSlideSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Titre *</label>
                  <input name="titre" value={slideForm.titre} onChange={handleSlideChange} required placeholder="Titre du slide" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ordre</label>
                  <input name="ordre" type="number" value={slideForm.ordre} onChange={handleSlideChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                <input name="description" value={slideForm.description} onChange={handleSlideChange} placeholder="Sous-titre affiché sur l'image" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">URL de l'image *</label>
                <input name="imageUrl" value={slideForm.imageUrl} onChange={handleSlideChange} required placeholder="https://example.com/image.jpg" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
              </div>
              {slidePreview && (
                <div className="rounded-lg overflow-hidden h-40 bg-gray-100">
                  <img src={slidePreview} alt="preview" className="w-full h-full object-cover" onError={(e) => e.target.style.display="none"}/>
                </div>
              )}
              <div className="flex items-center gap-2">
                <input type="checkbox" id="slideActif" name="actif" checked={slideForm.actif} onChange={handleSlideChange} className="w-4 h-4 accent-blue-600"/>
                <label htmlFor="slideActif" className="text-sm font-medium text-gray-700">Afficher sur le site</label>
              </div>
              <div className="flex gap-3">
                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-medium">{slideEditId ? "💾 Enregistrer" : "🚀 Ajouter"}</button>
                <button type="button" onClick={() => { setSlideFormOpen(false); setSlideForm(EMPTY_SLIDE); setSlideEditId(null); setSlidePreview(""); }} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-medium">Annuler</button>
              </div>
            </form>
          </div>
        )}

        {slides.length === 0 ? (
          <div className="text-center py-8 text-gray-400">Aucun slide pour l'instant.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {slides.map((slide) => (
              <div key={slide._id} className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
                <div className="h-36 bg-gray-100 relative">
                  <img src={slide.imageUrl} alt={slide.titre} className="w-full h-full object-cover" onError={(e) => e.target.style.display="none"}/>
                  {!slide.actif && <div className="absolute top-2 right-2 bg-red-100 text-red-500 text-xs px-2 py-1 rounded-full font-medium">Masqué</div>}
                  <div className="absolute top-2 left-2 bg-black/50 text-white text-xs px-2 py-1 rounded-full">#{slide.ordre}</div>
                </div>
                <div className="p-3">
                  <h4 className="font-semibold text-gray-800 text-sm mb-1 truncate">{slide.titre}</h4>
                  {slide.description && <p className="text-gray-400 text-xs truncate">{slide.description}</p>}
                  <div className="flex gap-2 mt-3">
                    <button onClick={() => handleSlideEdit(slide)} className="flex-1 text-xs bg-blue-50 text-blue-600 px-3 py-1.5 rounded-lg hover:bg-blue-100 transition font-medium">✏️ Modifier</button>
                    <button onClick={() => handleSlideDelete(slide._id)} className="flex-1 text-xs bg-red-50 text-red-500 px-3 py-1.5 rounded-lg hover:bg-red-100 transition font-medium">🗑️ Supprimer</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>


      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-gray-900">🔲 Grille d'images</h2>
          <button
            onClick={() => { setTuileFormOpen(true); setTuileForm(EMPTY_TUILE); setTuileEditId(null); }}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition font-medium"
          >
            ＋ Ajouter une image
          </button>
        </div>

        {tuileFormOpen && (
          <div className="bg-white border-2 border-purple-200 rounded-xl p-6 mb-6">
            <h3 className="text-lg font-bold mb-4">{tuileEditId ? "✏️ Modifier" : "➕ Nouvelle image"}</h3>
            <form onSubmit={handleTuileSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Titre (optionnel)</label>
                  <input name="titre" value={tuileForm.titre} onChange={handleTuileChange} placeholder="Titre au survol" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"/>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Taille</label>
                  <select name="taille" value={tuileForm.taille} onChange={handleTuileChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500">
                    <option value="petite">Petite (1 colonne)</option>
                    <option value="grande">Grande (2 colonnes)</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">URL de l'image *</label>
                <input name="imageUrl" value={tuileForm.imageUrl} onChange={handleTuileChange} required placeholder="https://example.com/image.jpg" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"/>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Lien au clic (optionnel)</label>
                <input name="lien" value={tuileForm.lien} onChange={handleTuileChange} placeholder="https://..." className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"/>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ordre</label>
                  <input name="ordre" type="number" value={tuileForm.ordre} onChange={handleTuileChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"/>
                </div>
              </div>
              {tuilePreview && (
                <div className="rounded-lg overflow-hidden h-40 bg-gray-100">
                  <img src={tuilePreview} alt="preview" className="w-full h-full object-cover" onError={(e) => e.target.style.display="none"}/>
                </div>
              )}
              <div className="flex items-center gap-2">
                <input type="checkbox" id="tuileActif" name="actif" checked={tuileForm.actif} onChange={handleTuileChange} className="w-4 h-4 accent-purple-600"/>
                <label htmlFor="tuileActif" className="text-sm font-medium text-gray-700">Afficher sur le site</label>
              </div>
              <div className="flex gap-3">
                <button type="submit" className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition font-medium">{tuileEditId ? "💾 Enregistrer" : "🚀 Ajouter"}</button>
                <button type="button" onClick={() => { setTuileFormOpen(false); setTuileForm(EMPTY_TUILE); setTuileEditId(null); setTuilePreview(""); }} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-medium">Annuler</button>
              </div>
            </form>
          </div>
        )}

        {tuiles.length === 0 ? (
          <div className="text-center py-8 text-gray-400">Aucune image pour l'instant.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {tuiles.map((tuile) => (
              <div key={tuile._id} className={`bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden ${tuile.taille === "grande" ? "lg:col-span-2" : ""}`}>
                <div className="h-36 bg-gray-100 relative">
                  <img src={tuile.imageUrl} alt={tuile.titre} className="w-full h-full object-cover" onError={(e) => e.target.style.display="none"}/>
                  {!tuile.actif && <div className="absolute top-2 right-2 bg-red-100 text-red-500 text-xs px-2 py-1 rounded-full font-medium">Masqué</div>}
                  <div className="absolute top-2 left-2 bg-purple-500/70 text-white text-xs px-2 py-1 rounded-full">{tuile.taille === "grande" ? "⬛ Grande" : "▪️ Petite"}</div>
                </div>
                <div className="p-3">
                  <h4 className="font-semibold text-gray-800 text-sm mb-1 truncate">{tuile.titre || "Sans titre"}</h4>
                  <div className="flex gap-2 mt-3">
                    <button onClick={() => handleTuileEdit(tuile)} className="flex-1 text-xs bg-purple-50 text-purple-600 px-3 py-1.5 rounded-lg hover:bg-purple-100 transition font-medium">✏️ Modifier</button>
                    <button onClick={() => handleTuileDelete(tuile._id)} className="flex-1 text-xs bg-red-50 text-red-500 px-3 py-1.5 rounded-lg hover:bg-red-100 transition font-medium">🗑️ Supprimer</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

    </div>
  );
}*/


import { useState, useEffect } from "react";
import API_URL from "../config";

const EMPTY_SLIDE = { titre: "", description: "", imageUrl: "", ordre: 0, actif: true };
const EMPTY_TUILE = { titre: "", imageUrl: "", lien: "", taille: "petite", ordre: 0, actif: true };

export default function AdminSlide() {
  const [slides, setSlides] = useState([]);
  const [tuiles, setTuiles] = useState([]);
  const [slideForm, setSlideForm] = useState(EMPTY_SLIDE);
  const [tuileForm, setTuileForm] = useState(EMPTY_TUILE);
  const [slideEditId, setSlideEditId] = useState(null);
  const [tuileEditId, setTuileEditId] = useState(null);
  const [slideFormOpen, setSlideFormOpen] = useState(false);
  const [tuileFormOpen, setTuileFormOpen] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [slidePreview, setSlidePreview] = useState("");
  const [tuilePreview, setTuilePreview] = useState("");
  const [slideUploading, setSlideUploading] = useState(false);
  const [tuileUploading, setTuileUploading] = useState(false);

  useEffect(() => { fetchSlides(); fetchTuiles(); }, []);

  const fetchSlides = async () => {
    const res = await fetch(`${API_URL}/api/slides/all`);
    setSlides(await res.json());
  };

  const fetchTuiles = async () => {
    const res = await fetch(`${API_URL}/api/tuiles/all`);
    setTuiles(await res.json());
  };

  const notify = (msg) => {
    setFeedback(msg);
    setTimeout(() => setFeedback(""), 3000);
  };

  // Upload image vers Cloudinary via le backend
  const handleImageUpload = async (file, type) => {
    const formData = new FormData();
    formData.append("image", file);
    if (type === "slide") setSlideUploading(true);
    else setTuileUploading(true);

    try {
      const res = await fetch(`${API_URL}/api/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (data.url) {
        if (type === "slide") {
          setSlideForm(prev => ({ ...prev, imageUrl: data.url }));
          setSlidePreview(data.url);
        } else {
          setTuileForm(prev => ({ ...prev, imageUrl: data.url }));
          setTuilePreview(data.url);
        }
        notify("✅ Image uploadée !");
      }
    } catch (err) {
      notify("❌ Erreur upload image");
    } finally {
      if (type === "slide") setSlideUploading(false);
      else setTuileUploading(false);
    }
  };

  // ── Slides handlers ──
  const handleSlideChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    setSlideForm(prev => ({ ...prev, [name]: val }));
    if (name === "imageUrl") setSlidePreview(value);
  };

  const handleSlideSubmit = async (e) => {
    e.preventDefault();
    const method = slideEditId ? "PUT" : "POST";
    const url = slideEditId ? `${API_URL}/api/slides/${slideEditId}` : `${API_URL}/api/slides`;
    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(slideForm),
    });
    if (res.ok) {
      notify(slideEditId ? "✅ Slide modifié !" : "✅ Slide ajouté !");
      setSlideForm(EMPTY_SLIDE);
      setSlideEditId(null);
      setSlideFormOpen(false);
      setSlidePreview("");
      fetchSlides();
    }
  };

  const handleSlideEdit = (slide) => {
    setSlideForm({ titre: slide.titre, description: slide.description, imageUrl: slide.imageUrl, ordre: slide.ordre, actif: slide.actif });
    setSlideEditId(slide._id);
    setSlidePreview(slide.imageUrl);
    setSlideFormOpen(true);
  };

  const handleSlideDelete = async (id) => {
    if (!window.confirm("Supprimer ce slide ?")) return;
    await fetch(`${API_URL}/api/slides/${id}`, { method: "DELETE" });
    notify("🗑️ Slide supprimé");
    fetchSlides();
  };

  // ── Tuiles handlers ──
  const handleTuileChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    setTuileForm(prev => ({ ...prev, [name]: val }));
    if (name === "imageUrl") setTuilePreview(value);
  };

  const handleTuileSubmit = async (e) => {
    e.preventDefault();
    const method = tuileEditId ? "PUT" : "POST";
    const url = tuileEditId ? `${API_URL}/api/tuiles/${tuileEditId}` : `${API_URL}/api/tuiles`;
    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tuileForm),
    });
    if (res.ok) {
      notify(tuileEditId ? "✅ Tuile modifiée !" : "✅ Tuile ajoutée !");
      setTuileForm(EMPTY_TUILE);
      setTuileEditId(null);
      setTuileFormOpen(false);
      setTuilePreview("");
      fetchTuiles();
    }
  };

  const handleTuileEdit = (tuile) => {
    setTuileForm({ titre: tuile.titre, imageUrl: tuile.imageUrl, lien: tuile.lien, taille: tuile.taille, ordre: tuile.ordre, actif: tuile.actif });
    setTuileEditId(tuile._id);
    setTuilePreview(tuile.imageUrl);
    setTuileFormOpen(true);
  };

  const handleTuileDelete = async (id) => {
    if (!window.confirm("Supprimer cette tuile ?")) return;
    await fetch(`${API_URL}/api/tuiles/${id}`, { method: "DELETE" });
    notify("🗑️ Tuile supprimée");
    fetchTuiles();
  };

  // Composant réutilisable pour le champ image (URL + upload)
  const ImageInput = ({ type, form, preview, uploading }) => (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">Image *</label>

      {/* Upload depuis PC */}
      <div className="flex items-center gap-3">
        <label className={`cursor-pointer px-4 py-2 rounded-lg text-sm font-medium transition ${type === "slide" ? "bg-blue-50 text-blue-600 hover:bg-blue-100 border border-blue-200" : "bg-purple-50 text-purple-600 hover:bg-purple-100 border border-purple-200"}`}>
          {uploading ? "⏳ Upload..." : "📁 Choisir depuis mon PC"}
          <input
            type="file"
            accept="image/*"
            className="hidden"
            disabled={uploading}
            onChange={(e) => {
              if (e.target.files[0]) handleImageUpload(e.target.files[0], type);
            }}
          />
        </label>
        {preview && <span className="text-xs text-green-600 font-medium">✅ Image prête</span>}
      </div>

      {/* Ou URL */}
      <div className="flex items-center gap-2">
        <div className="flex-1 h-px bg-gray-200" />
        <span className="text-xs text-gray-400">ou colle une URL</span>
        <div className="flex-1 h-px bg-gray-200" />
      </div>
      <input
        name="imageUrl"
        value={form.imageUrl}
        onChange={type === "slide" ? handleSlideChange : handleTuileChange}
        placeholder="https://example.com/image.jpg"
        className={`w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 ${type === "slide" ? "focus:ring-blue-500" : "focus:ring-purple-500"}`}
      />

      {/* Prévisualisation */}
      {preview && (
        <div className="rounded-lg overflow-hidden h-40 bg-gray-100">
          <img src={preview} alt="preview" className="w-full h-full object-cover" onError={(e) => e.target.style.display = "none"} />
        </div>
      )}
    </div>
  );

  return (
    <div className="mt-10 space-y-12">

      {feedback && (
        <div className="p-3 bg-green-50 border border-green-200 text-green-700 rounded-lg text-sm">{feedback}</div>
      )}

      {/* ── SECTION CARROUSEL ── */}
      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-gray-900">🖼️ Carrousel</h2>
          <button
            onClick={() => { setSlideFormOpen(true); setSlideForm(EMPTY_SLIDE); setSlideEditId(null); setSlidePreview(""); }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-medium"
          >
            ＋ Ajouter un slide
          </button>
        </div>

        {slideFormOpen && (
          <div className="bg-white border-2 border-blue-200 rounded-xl p-6 mb-6">
            <h3 className="text-lg font-bold mb-4">{slideEditId ? "✏️ Modifier" : "➕ Nouveau slide"}</h3>
            <form onSubmit={handleSlideSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Titre *</label>
                  <input name="titre" value={slideForm.titre} onChange={handleSlideChange} required placeholder="Titre du slide" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ordre</label>
                  <input name="ordre" type="number" value={slideForm.ordre} onChange={handleSlideChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                <input name="description" value={slideForm.description} onChange={handleSlideChange} placeholder="Sous-titre affiché sur l'image" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
              </div>

              <ImageInput type="slide" form={slideForm} preview={slidePreview} uploading={slideUploading} />

              <div className="flex items-center gap-2">
                <input type="checkbox" id="slideActif" name="actif" checked={slideForm.actif} onChange={handleSlideChange} className="w-4 h-4 accent-blue-600" />
                <label htmlFor="slideActif" className="text-sm font-medium text-gray-700">Afficher sur le site</label>
              </div>
              <div className="flex gap-3">
                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-medium">{slideEditId ? "💾 Enregistrer" : "🚀 Ajouter"}</button>
                <button type="button" onClick={() => { setSlideFormOpen(false); setSlideForm(EMPTY_SLIDE); setSlideEditId(null); setSlidePreview(""); }} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-medium">Annuler</button>
              </div>
            </form>
          </div>
        )}

        {slides.length === 0 ? (
          <div className="text-center py-8 text-gray-400">Aucun slide pour l'instant.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {slides.map((slide) => (
              <div key={slide._id} className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
                <div className="h-36 bg-gray-100 relative">
                  <img src={slide.imageUrl} alt={slide.titre} className="w-full h-full object-cover" onError={(e) => e.target.style.display = "none"} />
                  {!slide.actif && <div className="absolute top-2 right-2 bg-red-100 text-red-500 text-xs px-2 py-1 rounded-full font-medium">Masqué</div>}
                  <div className="absolute top-2 left-2 bg-black/50 text-white text-xs px-2 py-1 rounded-full">#{slide.ordre}</div>
                </div>
                <div className="p-3">
                  <h4 className="font-semibold text-gray-800 text-sm mb-1 truncate">{slide.titre}</h4>
                  {slide.description && <p className="text-gray-400 text-xs truncate">{slide.description}</p>}
                  <div className="flex gap-2 mt-3">
                    <button onClick={() => handleSlideEdit(slide)} className="flex-1 text-xs bg-blue-50 text-blue-600 px-3 py-1.5 rounded-lg hover:bg-blue-100 transition font-medium">✏️ Modifier</button>
                    <button onClick={() => handleSlideDelete(slide._id)} className="flex-1 text-xs bg-red-50 text-red-500 px-3 py-1.5 rounded-lg hover:bg-red-100 transition font-medium">🗑️ Supprimer</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── SECTION TUILES ── */}
      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-gray-900">🔲 Grille d'images</h2>
          <button
            onClick={() => { setTuileFormOpen(true); setTuileForm(EMPTY_TUILE); setTuileEditId(null); setTuilePreview(""); }}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition font-medium"
          >
            ＋ Ajouter une image
          </button>
        </div>

        {tuileFormOpen && (
          <div className="bg-white border-2 border-purple-200 rounded-xl p-6 mb-6">
            <h3 className="text-lg font-bold mb-4">{tuileEditId ? "✏️ Modifier" : "➕ Nouvelle image"}</h3>
            <form onSubmit={handleTuileSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Titre (optionnel)</label>
                  <input name="titre" value={tuileForm.titre} onChange={handleTuileChange} placeholder="Titre au survol" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Taille</label>
                  <select name="taille" value={tuileForm.taille} onChange={handleTuileChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500">
                    <option value="petite">Petite (1 colonne)</option>
                    <option value="grande">Grande (2 colonnes)</option>
                  </select>
                </div>
              </div>

              <ImageInput type="tuile" form={tuileForm} preview={tuilePreview} uploading={tuileUploading} />

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Lien au clic (optionnel)</label>
                <input name="lien" value={tuileForm.lien} onChange={handleTuileChange} placeholder="https://..." className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ordre</label>
                <input name="ordre" type="number" value={tuileForm.ordre} onChange={handleTuileChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
              </div>
              <div className="flex items-center gap-2">
                <input type="checkbox" id="tuileActif" name="actif" checked={tuileForm.actif} onChange={handleTuileChange} className="w-4 h-4 accent-purple-600" />
                <label htmlFor="tuileActif" className="text-sm font-medium text-gray-700">Afficher sur le site</label>
              </div>
              <div className="flex gap-3">
                <button type="submit" className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition font-medium">{tuileEditId ? "💾 Enregistrer" : "🚀 Ajouter"}</button>
                <button type="button" onClick={() => { setTuileFormOpen(false); setTuileForm(EMPTY_TUILE); setTuileEditId(null); setTuilePreview(""); }} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-medium">Annuler</button>
              </div>
            </form>
          </div>
        )}

        {tuiles.length === 0 ? (
          <div className="text-center py-8 text-gray-400">Aucune image pour l'instant.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {tuiles.map((tuile) => (
              <div key={tuile._id} className={`bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden ${tuile.taille === "grande" ? "lg:col-span-2" : ""}`}>
                <div className="h-36 bg-gray-100 relative">
                  <img src={tuile.imageUrl} alt={tuile.titre} className="w-full h-full object-cover" onError={(e) => e.target.style.display = "none"} />
                  {!tuile.actif && <div className="absolute top-2 right-2 bg-red-100 text-red-500 text-xs px-2 py-1 rounded-full font-medium">Masqué</div>}
                  <div className="absolute top-2 left-2 bg-purple-500/70 text-white text-xs px-2 py-1 rounded-full">{tuile.taille === "grande" ? "⬛ Grande" : "▪️ Petite"}</div>
                </div>
                <div className="p-3">
                  <h4 className="font-semibold text-gray-800 text-sm mb-1 truncate">{tuile.titre || "Sans titre"}</h4>
                  <div className="flex gap-2 mt-3">
                    <button onClick={() => handleTuileEdit(tuile)} className="flex-1 text-xs bg-purple-50 text-purple-600 px-3 py-1.5 rounded-lg hover:bg-purple-100 transition font-medium">✏️ Modifier</button>
                    <button onClick={() => handleTuileDelete(tuile._id)} className="flex-1 text-xs bg-red-50 text-red-500 px-3 py-1.5 rounded-lg hover:bg-red-100 transition font-medium">🗑️ Supprimer</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

    </div>
  );
}